<template>
  <base-container>
    <div class="flex-align-middle mb-normal">
      <div class="d-flex gap-small" style="flex-wrap: wrap">
        <h2 class="color-corp"><slot name="title"></slot> {{ title }}</h2>
        <div
          class="d-flex gap-small align-center flex-wrap ml-auto"
          style="flex-shrink: 0; max-width: 100%"
        >
          <loader-element
            v-if="isLoading"
            :size="20"
          ></loader-element>

          <a
            v-for="btn in buttons"
            :key="btn.title"
            @click="btn.onClick()"
            class="btn-link h2 adaptive"
            :class="{'is-loading': isLoading && btn.title === loadingBtnTitle}"
            style="flex-shrink: 0"
            >{{ btn.title }}
          </a>
        </div>
      </div>
    </div>

    <div
      :class="
        small
          ? ''
          : `section-${sections} ${
              sections === 4 ? 'section-2_smaller-adaptive' : ''
            }`
      "
    >
      <slot name="default"></slot>
    </div>
  </base-container>
</template>

<script>
import BaseContainer from "@/layouts/BaseContainer";
import LoaderElement from "@/components/LoaderElement.vue";
export default {
  name: "RecentVisitListLayout",
  components: {
    LoaderElement,
    BaseContainer,
  },
  props: {
    title: { type: String, default: "Заголовок" },
    buttons: {
      type: Array,
      default: () => [
        // {
        //   title: "все посещения",
        //   onClick: function () {
        //     console.log(this.title);
        //   },
        // },
      ],
    },
    isLoading: { type: Boolean, default: false },
    loadingBtnTitle: { type: String, default: '' },
    small: {
      type: Boolean,
      default: false,
    },
    sections: {
      type: [Number, String],
      default: 4,
      validator(value) {
        return 1 >= value && value <= 4;
      },
    },
  },
};
</script>

<style scoped lang="scss">
.is-loading {
  pointer-events: none;
  opacity: 0.2;
}
</style>
